import { render } from "./OnlineTaskList.vue?vue&type=template&id=3a5b8a75"
import script from "./OnlineTaskList.vue?vue&type=script&lang=js"
export * from "./OnlineTaskList.vue?vue&type=script&lang=js"

import "./OnlineTaskList.vue?vue&type=style&index=0&id=3a5b8a75&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__